module.exports = __webpack_public_path__ + "img/pro5.4c319934.png";